import { PORT_RADIUS } from './ellipsis.tsx';
import { toPoint, type Point } from './toPortInfo.tsx';
import { add } from './percentageOfLine.tsx';
import { combinePath, lineRight, lineUp, lineLeft, lineDown, move } from './lineLeft.tsx';

const CONTENT_PADDING_LEFT = 12;
const CONTENT_PADDING = 12;

const TRANSITION_PATH_WIDTH = 90;
const TRANSITION_PATH_HEIGHT = 50;
const TRANSITIONS_GAP = 30;

export const CONTAINER_WIDTH = 160;
const MIN_LOZENGE_WIDTH = 40;
export const LOZENGE_HEIGHT = 24;
export const LOZENGE_BORDER_RADIUS: number = LOZENGE_HEIGHT / 2;
const LOZENGE_PADDING = 10; // total padding around left and right of lozenge, L + R value
const LABEL_HEIGHT = 24;

export const getGlobalLoopTransitionPosition = (position: Point, index: number): Point =>
	add(
		position,
		toPoint(
			CONTENT_PADDING_LEFT,
			CONTENT_PADDING + index * (TRANSITION_PATH_HEIGHT + TRANSITIONS_GAP),
		),
	);

export const getContainerHeight = (transitionsCount: number): number =>
	CONTENT_PADDING * 2 + transitionsCount * (TRANSITION_PATH_HEIGHT + TRANSITIONS_GAP);

export const getLozengePosition = (position: Point): Point => ({
	x: position.x,
	y: position.y + TRANSITION_PATH_HEIGHT,
});

export const getLozengeTextPosition = (lozengePosition: Point, lozengeWidth: number): Point =>
	add(lozengePosition, toPoint(lozengeWidth / 2, LOZENGE_HEIGHT / 2 + 4));

export const globalLoopedTransitionRoute = (lozengePosition: Point, lozengeWidth: number) => {
	const lozengeMiddleRight = add(lozengePosition, toPoint(lozengeWidth, LOZENGE_HEIGHT / 2));

	return combinePath(
		move(lozengeMiddleRight),
		lineRight(TRANSITION_PATH_WIDTH - lozengeWidth / 2),
		lineUp(TRANSITION_PATH_HEIGHT),
		lineLeft(TRANSITION_PATH_WIDTH),
		lineDown(TRANSITION_PATH_HEIGHT - LOZENGE_HEIGHT / 2 - PORT_RADIUS),
	);
};

export const getLozengeWidth = (textWidth: number): number =>
	Math.max(MIN_LOZENGE_WIDTH, textWidth + LOZENGE_PADDING);

export const getLabelPosition = (position: Point): Point =>
	add(position, toPoint(TRANSITION_PATH_WIDTH - 5, LABEL_HEIGHT / 2));

export const getArrowPosition = (lozengePosition: Point, lozengeWidth: number): Point =>
	add(lozengePosition, toPoint(lozengeWidth / 2, 0));
